import { APIv4 } from 'src/libs/axios';

export const addMenuCategories = ({
  menuId,
  ids,
}: {
  menuId: number;
  ids: number[];
}): Promise<void> =>
  APIv4.post(`/menus/${menuId}/categories`, { ids }).then(
    (response) => response.data
  );
